module.exports = __webpack_public_path__ + "img/banner-mobile.f1e5d152.png";